export default [
  "#FF8A06",
  "#10AEF5",
  "#FFCA00",
  "#FF6201",
  "#FFCA00",
  "#10C49F",
  "#FF6201",
  "#10AEF5",
  "#10C49F",
  "#FF8A06"
];
